

export default {
  // 块头 主要用于项目和标签列表头
  name: 'SectionHead',
  components: {},
  props: {
    iconClass: String,
    label: String
  },
  data: function data() {
    return {};
  },

  computed: {},
  watch: {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},

  methods: {}
};